import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import CardBlock from "../../../components/CardBlock/CardBlock";
import IndexHeader from "components/Headers/IndexHeader.js";
import {
  getProducts,
  getProductDetail,
  getProductImageDetail,
  getProductRelated,
} from "../../../redux/actions/products_actions";
import { HOST_URL } from "../../../utils/misc.js";
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Rating } from 'primereact/rating';
import NProgress from 'nprogress';
import Skeleton from 'react-loading-skeleton';

const Product = (props) => {  
  // Get CategoryName
  const category = (props.match.params.category).toString();
  const [layout, setLayout] = useState('grid');
  const [sortKey, setSortKey] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [sortField, setSortField] = useState(null);
  const sortOptions = [
      {label: 'Giá giảm dần', value: '!price'},
      {label: 'Giá tăng dần', value: 'price'},
  ];

  useEffect(() => { 
    NProgress.start();
    // Scroll To Top
    window.scrollTo(0, 0)
    
    if(category != ""){
      props.dispatch(getProducts(category))
    }
  }, [window.location.pathname]);

  // props.<combine>.<reducer>.<action>.<properties>
  const [imageLoading, setImageLoading] = useState(true);

  const handleImageLoaded = () => {
    setImageLoading(false);
  }

  const formatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'VND',
    minimumFractionDigits: 0
  })

  const loadProductDetail = () => {
    const id = props.productId;
    const keyword = ""
    window.scrollTo({top: 0, left: 0, behavior: 'smooth' })
    props.dispatch(getProductImageDetail(id, keyword)).then(res =>{
      if(res.payload){
        if(res.payload.productImage.lenght > 0) {
          props.dispatch(getProductDetail(id, keyword)).then(res =>{
            if(res.payload.product != undefined){
              props.dispatch(getProductRelated(res.payload.product.productId, res.payload.product.categoryName))
            }
            else{
              props.history.push('/')
            }
          })
        }
      }
    })
  }

  const onSortChange = (event) => {
    const value = event.value;

    if (value.indexOf('!') === 0) {
        setSortOrder(-1);
        setSortField(value.substring(1, value.length));
        setSortKey(value);
    }
    else {
        setSortOrder(1);
        setSortField(value);
        setSortKey(value);
    }
  }

  const renderListItem = (data) => {
      return (
        <div className="p-col-12">
          <NavLink to={`/product-detail/${data.productId}`} onClick={loadProductDetail} style={{color:"black"}}>
            <div className="product-list-item cardHover">
                { imageLoading && <Skeleton height={140}/> }
                <img src={data.image} onLoad={handleImageLoaded.bind(this)} alt={data.productName}/>
                <div className="product-list-detail">
                    <div className="product-name">{data.productName}</div>
                    <div className="product-description">{data.productName}</div>
                    <i className="pi pi-tag product-category-icon"></i><span className="product-category">{data.categoryName}</span>
                </div>
                <div className="product-list-action">
                  <div>
                    <label className={data.stockQuantity > 0 ? `label label-success` : `label label-danger`}>{data.stockQuantity > 0 ? 'Còn Hàng' : 'Tạm Hết Hàng'}</label>
                  </div>
                  <div className="text-center">
                    <span className="text-default">{formatter.format(data.price)}</span>
                  </div>
                </div>
            </div>
          </NavLink>
        </div>
      );
  }

  const renderGridItem = (data) => {
      return (
        <div className="p-col-12 p-md-4">
          <NavLink to={`/product-detail/${data.productId}`} onClick={loadProductDetail} style={{color:"black"}}>
            <div className="product-grid-item cardHover"> 
                <div className="product-grid-item-top">
                    <div>
                        <i className="pi pi-tag product-category-icon"></i>
                        <span className="product-category">{data.categoryName}</span>
                    </div>
                    <label className={data.stockQuantity > 0 ? `label label-success` : `label label-danger`}>{data.stockQuantity > 0 ? 'Còn Hàng' : 'Tạm Hết Hàng'}</label>
                </div>
                <div className="product-grid-item-content">
                  { imageLoading && <Skeleton height={200}/> }
                  <img src={data.image} onLoad={handleImageLoaded.bind(this)} alt={data.productName}/>
                  <div className="product-name">{data.productName}</div>
                  <div className="product-description">{data.notes}</div>
                </div>
                <div className="text-center">
                    <span className="text-default">{formatter.format(data.price)}</span>
                </div>
            </div>
          </NavLink>
        </div>
      );
  }

  const itemTemplate = (product, layout) => {
      if (!product) {
          return;
      }

      if (layout === 'list')
          return renderListItem(product);
      else if (layout === 'grid')
          return renderGridItem(product);
  }

  const renderHeader = () => {
      return (
          <div className="p-grid p-nogutter">
              <div className="p-col-6" style={{textAlign: 'left'}}>
                <Dropdown options={sortOptions} value={sortKey} optionLabel="label" placeholder="Sắp xếp theo" onChange={onSortChange}/>
              </div>
              <div className="p-col-6" style={{textAlign: 'right'}}>
                <DataViewLayoutOptions layout={layout} onChange={(e) => setLayout(e.value)} />
              </div>
          </div>
      );
  }

  const header = renderHeader();

  if(props.products.product) {
    NProgress.done();
    return (
      <>
        <IndexHeader title={category.toUpperCase()} imageUrl={HOST_URL + props.products.product.products[0].imagePage} minHeight="500" />
        <div className="container">
          <div className="text-center productTitle"><h6>Sản phẩm {category}</h6></div> 
          {/* <CardBlock
            list={props.products.product.products}
            type="sofa"
            title="All Sofa Products"
          /> */}
          <div className="dataview">
            <div className="card" style={{ transform: 'none' }}>
                <DataView value={props.products.product.products} layout={layout} header={header}
                itemTemplate={itemTemplate} paginator rows={6}
                sortOrder={sortOrder} sortField={sortField} />
            </div>
        </div>
        </div>
      </>
    );
  }
  else {
    return(
      <>
        <div className="container">
          <div className="row justify-content-center">
            <div className="text-center loading">
              <img src={HOST_URL + props.templates.templates.templateProperties.image_loading} style={{width: 150}} />       
            </div>
          </div>
        </div>
      </>
    )
  }
};
const mapStateToProps = (state) => {
  return {
    products: state.products,
    templates: state.templates,
  };
};
export default connect(mapStateToProps)(Product);
